// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const ModelIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M17.82 4.07c1.42 0 2.58 1.16 2.58 2.59 0 1.42-1.16 2.58-2.58 2.58s-2.59-1.16-2.59-2.58 1.16-2.59 2.59-2.59m0 7.27c2.58 0 4.68-2.1 4.68-4.68s-2.1-4.68-4.68-4.68-4.69 2.1-4.69 4.68 2.1 4.68 4.69 4.68m-7.45 2.32c-.4-.4-1.07-.4-1.48 0l-2.47 2.47-2.47-2.47c-.41-.4-1.08-.4-1.49 0s-.4 1.07 0 1.49l2.47 2.47-2.47 2.47c-.4.4-.4 1.07 0 1.48.2.2.48.3.74.3q.42 0 .75-.3l2.47-2.47 2.47 2.47q.32.3.74.3t.74-.3c.41-.4.41-1.07 0-1.48L7.9 17.62l2.47-2.47c.41-.42.41-1.08 0-1.49"
        opacity=".5"
      />
      <path d="m3.6 9.03 2.89-5h.06L9.4 9.08zm4.76-6.05c-.38-.66-1.07-1.06-1.84-1.06s-1.46.4-1.85 1.06l-2.88 5c-.39.67-.39 1.46 0 2.13.38.67 1.07 1.07 1.84 1.07H9.4c.77 0 1.46-.4 1.85-1.07.38-.67.38-1.46 0-2.13zm11.95 16.76q-.02.23-.24.24h-4.4q-.21-.02-.23-.24v-4.4q.02-.21.24-.23h4.4q.21.02.23.24zm-.24-6.73h-4.4c-1.28 0-2.33 1.05-2.33 2.34v4.4c0 1.28 1.05 2.33 2.34 2.33h4.4c1.28 0 2.33-1.05 2.33-2.34v-4.4c0-1.28-1.05-2.33-2.34-2.33" />
    </g>
  </SvgIcon>
);

export default ModelIcon;
